import {identity} from 'lodash';

export default ({
  url,
  headers = [],
  withCredentials = false,
  parse = identity,
}) => {
  const xhr = new XMLHttpRequest();

  xhr.open('GET', url);

  headers.forEach((h) => {
    xhr.setRequestHeader(h.header, h.value);
  });

  if (withCredentials) {
    xhr.withCredentials = true;
  }

  const promise = new Promise((resolve, reject) => {
    xhr.onload = () => {
      if (xhr.status === 200) {
        resolve(parse(xhr.responseText));
      } else {
        reject({
          status: xhr.status,
          statusText: xhr.statusText,
        });
      }
    };

    xhr.onerror = () => reject({status: xhr.status});
  });

  xhr.send();

  return promise;
};
